<template>
    <div :class="containerClass" @scroll="onScroll">
        <!-- TITLE AND BUTTONS -->
        <div v-if="hasTitleSlot" class="flex-level jc-space mb-3">
            <h2 class="m-0 typographies-heading-h2">
                <slot name="title"></slot>
                <span class="grey ml-2"><slot name="subtitle"></slot></span>
            </h2>

            <!-- BUTTONS SLOT -->
            <slot name="buttons">
                <ul v-if="buttons && buttons.length > 0" class="list-inline">
                    <li v-for="(button, index) in buttons" :key="index">
                        <!-- Call vue method -->
                        <el-tooltip
                            :content="$t.__('common.labels.no_necessary_rights')"
                            placement="top"
                            :disabled="hasAccess(button.permission, permissions)"
                        >
                            <a
                                v-if="button.type === 'vuejs'"
                                class="btn-compass-ish"
                                :data-upsell="button.dataUpsell"
                                :class="
                                    !hasAccess(button.permission, permissions)
                                        ? 'btn-compass-ish--disabled'
                                        : button.primary
                                        ? 'btn-compass-ish--primary'
                                        : 'btn-compass-ish--secondary'
                                "
                                @click="
                                    callBus(button, {
                                        linkedid: button.linkedid,
                                        linkedtype: button.linkedtype,
                                    })
                                "
                            >
                                {{ button.label }}
                            </a>
                            <a
                                v-else-if="button.type === 'function'"
                                class="btn-compass-ish"
                                :data-upsell="button.dataUpsell"
                                :class="
                                    !hasAccess(button.permission, permissions)
                                        ? 'btn-compass-ish--disabled'
                                        : button.primary
                                        ? 'btn-compass-ish--primary'
                                        : 'btn-compass-ish--secondary'
                                "
                                @click="
                                    $emit(button.event, {
                                        params: {
                                            linkedid: button.linkedid,
                                            linkedtype: button.linkedtype,
                                        },
                                        disabled: !hasAccess(button.permission, permissions),
                                    })
                                "
                            >
                                {{ button.label }}
                            </a>
                            <!-- Call old JS method -->
                            <a
                                v-else
                                href="javascript:;"
                                class="btn-compass-ish"
                                :data-upsell="button.dataUpsell"
                                :class="
                                    !hasAccess(button.permission, permissions)
                                        ? 'btn-compass-ish--disabled'
                                        : button.primary
                                        ? 'btn-compass-ish--primary'
                                        : 'btn-compass-ish--secondary'
                                "
                                :onclick="
                                    !hasAccess(button.permission, permissions)
                                        ? null
                                        : buildUrl(button.callback, parameters)
                                "
                            >
                                {{ button.label }}
                            </a>
                        </el-tooltip>
                    </li>
                </ul>
            </slot>
        </div>

        <!-- TAB CONTENT -->
        <slot name="content">
            <slot name="placeholder" />
        </slot>
    </div>
</template>

<script>
import { buildUrl, hasAccess } from '../../../helpers';
import Feature from 'Services/Feature';

export default {
    props: {
        buttons: {
            type: Array,
            required: false,
            default: () => [],
        },
        permissions: {
            type: Object,
            required: false,
            default: () => {},
        },
        parameters: {
            type: [Array],
            required: false,
            default: () => [],
        },
    },

    data() {
        return {};
    },
    computed: {
        showNewVersion() {
            return Feature.isEnabled('overview-info-sidebar');
        },
        containerClass() {
            return this.showNewVersion ? 'tab-layout' : 'flex-level flex-column flex ov-reset';
        },
        hasTitleSlot() {
            if (this.$slots.title) {
                return true;
            }
            return false;
        },
    },

    methods: {
        buildUrl,
        hasAccess,
        callBus(action, data) {
            if (hasAccess(action.permission, this.permissions))
                action.disable ? null : EventBus.$emit(action.event, { ...data, ...action.params });
        },
        onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
            if (scrollTop + clientHeight >= scrollHeight) {
                this.$emit('scroll-bottom');
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.tab-layout {
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: var(--spacing-4) 0 0;
}
</style>
